define('flight-components/mixins/withPopover',[
  'flight/lib/compose',
  'flight-components/mixins/withToggle'
],

function(compose, withToggle){

  var withPopover = function withPopover() {

    var count = 0;

    /**
     *  Adds 'toggleState()'
     *  must implement onStateToggled(bool)
     */
    compose.mixin(this, [withToggle]);

    this.defaultAttrs({
      contentSelector: '.popover__content',
      containerSelector: '.wrapper',
      componentOverlayClassName: 'component__overlay',
      transitionSpeed: 0,
      easing: 'easeInOutExpo',
      autoPositionPopover: true,
      closeOnDocumentClick: true,
      maxWidth: false
    });



    /**
     * Determine if we should show or hide
     * @param ev
     * @param data
     */
    this.onStateToggled = function(ev, data) {
      this[data.isActive ? 'showPopover' : 'hidePopover']();    
    };

    this.popover = function(state) {
      if (state == 'show' && !this.attr.isActive) {
        this.toggleState();
      } else if (state == 'show') {
        return;
      } else if (state == 'hide' && this.attr.isActive) {
        this.toggleState();
      } else if (state == 'hide') {
        return;
      }
    };



    /**
     * Show the content
     * @param ev
     */
    this.showPopover = function() {

      var self = this;

      /** Calculate and set the popover's position */
      this.updatePosition();

      /** Show the popover */
      this.attr.$popoverContent.show();

      this.$node.addClass('on');


      setTimeout(function(){
        $(document).on('click.backdrop', function(ev){
          var target = $(ev.target);
          if (target.parents(self.attr.contentSelector).length < 1) {
            self.popover('hide');
          }
        });
      }, 0);

      /**
       * When activated, we should listen for viewport
       * resize events so we can reposition the menu.
       */
      this.on(document, 'uiViewportResized', this.updatePosition);

      this.trigger('popover.shown', {id: this.attr.popoverId});

    };





    /**
     * Hide the content
     * @param ev
     */
    this.hidePopover = function(ev) {

      
      $(document).off('click.backdrop');
      

      /** Stop listening to outside events */
      this.off(document, 'uiViewportResized');



      /** Wait for exit animation to complete then do cleanup */
      setTimeout((function(self){
        return function() {
          /** Hide the menu and move it back into the component DOM */
          self.attr.$popoverContent
              .hide()
              // .appendTo(self.$node);

          self.$node.removeClass('on');
        }
      })(this), this.attr.transitionSpeed);

      this.trigger('popover.hidden', {id: this.attr.popoverId});
    };

    this.updatePosition = function(ev, data) {
      if (!this.attr.autoPositionPopover) return;
      var popoverOffset = this.getPopoverOffset();
      this.attr.$popoverContent.css(popoverOffset);
    };


    /**
     *  Returns an object containing the popover dimensions and position
     */
    this.getPopoverOffset = function(){

      // TODO: enable popover to appear on different sides of element,
      // should automatically stay within viewport bounds

      var popoverOffset = this.$node.offset();
      var popoverWidth = this.$node.innerWidth();
      var contentWidth = this.attr.$popoverContent.innerWidth();
      var popoverPosition;

      if ($('body').hasClass('viewport-sm') || $('body').hasClass('viewport-xs')) {
        
        var left, width;
        if (window.innerWidth < 640) {
          left = 6;
          width = window.innerWidth - 12
        } else {
          left = (window.innerWidth / 2) - (620 / 2),
          width = 620
        }

        popoverPosition = {
          top: popoverOffset.top + this.select('toggleSelector').innerHeight() + 7,
          left: left,
          width: width
        }

      } else {
        popoverPosition = {
          top: '100%',
          left: '50%',
          marginLeft: (contentWidth / -2),
          marginTop: '8px'
        }
      }
      return popoverPosition;
    };


    this.after('initialize', function() {

      var self = this;

      /** Cache the jQuery selections */
      this.attr.$popoverContent = this.select('contentSelector');

      this.attr.popoverId = count++;

      this.on(document, 'uiViewportBreakpointChange', function() {
        self.popover('hide');
      });

      this.on('toggleStateChanged', this.onStateToggled);

    });






  };

  return withPopover;
});
